import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Button, MenuItem, Select, Stack, Tooltip, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/system";
import { GridActionsCellItem, GridRowModes } from "@mui/x-data-grid";
import { StyledLeadContainer,} from "../../../Components/Styled";
import DataGridTable from "../../../Components/DataGrid";
import LeadDialog from "../../../Components/LeadDialog";
import CheckIcon from '@mui/icons-material/Check';
import CancelIcon from "@mui/icons-material/Close";
import InfoIcon from "../../../Components/Widgets/InfoIcon";
import { handleValidateCodevalue,actionColumnWidth,LEAD_STATUS,RE_STATUS, ruleEngineLookupList, ROWS_TO_VIEW_IN_CHILD_TABLE } from "../../../Utility/constant";
import { createRequestData, getRequestData, updateRequestData } from "../../../Utility/apiHelper";
import { requestHideLoader, requestShowLoader } from "../../../Store/Global/action";
import SelectBoxWithLabel from "../../../Components/SelectBoxWithLable";
import BiztantuLoader from "../../../Components/Loader";
import tableBodyicon from '../../../Assets/images/tablebody_edit.png';
import tableEditicon from '../../../Assets/images/tableheader_edit.png';
import disabled_edit from '../../../Assets/images/disabled_edit.png';
import { requestGetAllTextfieldDetails } from "../../../Store/Customization/action";
import trashIcon from '../../../Assets/images/trashIcon.png';
import { useSnackbar } from 'notistack';
import RestoreFromTrashIcon from '@mui/icons-material/RestoreFromTrash';
import AutoCompleteComponent from "../../../Components/AutoCompleteComponenet";

const AllowedStatusDialog = ({open,handleClose}) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const internationalise = useSelector((state) => state?.internationalise?.currentHashMapData);
    const isLoadingprogress = useSelector(state => state.global.isLoading); 
    const dispatch = useDispatch();
    const [allowedStatusRows, setAllowedStatusRows] = useState([]);
    const initialRowsRef = useRef([]);
    const [dialogRowModesModel, setDialogRowModesModel] = useState({});
    const [clientLookupCodeOptions, setClientLookupCodeOptions] = useState([]);
    const [allowedValueOptions , setAllowedValueOptions] = useState([]);


    const [selectedEntity,setSelectedEntity] = useState(LEAD_STATUS);

useEffect(() => {
  if (!open) return;
  if(selectedEntity){
  getAllowedStatusData();
  }
}, [selectedEntity]);

const getAllowedStatusData = async () => {
    try {
    dispatch(requestShowLoader())
      // 1. Get lookup values for the dropdown/autocomplete
      const lookupResponse = await getRequestData(
        `${process.env.REACT_APP_BASE_URL}lookup/client/by-name?lookupTypeName=${selectedEntity}&clientId=1`
      );

      const lookupData = lookupResponse?.data ?? [];

      setAllowedValueOptions(lookupData);

      // 2. Get existing allowed-status rules
      const ruleResponse = await getRequestData(
  `${process.env.REACT_APP_BASE_URL}api/rule-engine/${selectedEntity}`
);

const existingData = ruleResponse?.data ?? [];

const existingClientLookupCodes = existingData.map(
    (item) => item?.clientLookupCode
);

const availableClientLookupCodeOptions = lookupData
    ?.map((item) => item?.name)
    ?.filter(
        (name) => !existingClientLookupCodes.includes(name)
    );

setClientLookupCodeOptions(availableClientLookupCodeOptions);

const rows = existingData.map((rule, index) => ({
    id: rule?.id ?? index,

    clientLookupCode: rule?.clientLookupCode,

    allowedValues: (rule?.allowedLookupCode ?? []).map(
        (value) =>
            lookupData?.find((item) => item?.name === value) ?? {
                name: value,
            }
    ),

    status:
        rule?.status ??
        RE_STATUS?.RE_STATUS_ACTIVE,

    isNew: false,
}));

setAllowedStatusRows(rows);
initialRowsRef.current = JSON.parse(JSON.stringify(rows));
    } catch (error) {
      console.error("Error loading allowed status data:", error);
    }
    finally {
        dispatch(requestHideLoader())
    }
  };

const handleToggleStatus = (id) => async () => {
    const currentRow = allowedStatusRows?.find(
        (row) => row?.id === id
    );

    if (!currentRow) {
        return;
    }
    if (currentRow?.isNew) {
        setAllowedStatusRows((prevRows) =>
            prevRows.filter((row) => row?.id !== id)
        );

        setDialogRowModesModel((prev) => {
            const updated = { ...prev };
            delete updated[id];
            return updated;
        });

        return;
    }

    const newStatus =
        currentRow?.status === RE_STATUS?.RE_STATUS_INACTIVE
            ?  RE_STATUS?.RE_STATUS_ACTIVE
            :  RE_STATUS?.RE_STATUS_INACTIVE;

    const updatedRows = allowedStatusRows?.map((row) =>
        row?.id === id
            ? {
                  ...row,
                  status: newStatus,
              }
            : row
    );

    setAllowedStatusRows(updatedRows);

    const payload = {
        lookupType: selectedEntity,
        status: newStatus,
        clientLookupCode: currentRow?.clientLookupCode,
        allowedLookupCode: (currentRow?.allowedValues ?? []).map(
            (item) => item?.name ?? item
        ),
    };

    try {
        dispatch(requestShowLoader());

        const url = `${process.env.REACT_APP_BASE_URL}api/rule-engine/${currentRow?.id}`;

        const response = await updateRequestData(payload, url);
        if (response?.status === "error") {
            enqueueSnackbar(
                handleValidateCodevalue(
                    internationalise,
                    "COMMON_PLEASE_TRY_AGAIN"
                ),
                {
                    variant: "error",
                }
            );
            return;
        }
      initialRowsRef.current = JSON.parse(JSON.stringify(updatedRows));
        dispatch(requestGetAllTextfieldDetails());
    } catch (error) {
        console.error("Error updating rule status:", error);

        setAllowedStatusRows(allowedStatusRows);
    } finally {
        dispatch(requestHideLoader());
    }
};
const handleAllowedValuesChange = (event, newValue, params) => {
    params.api.setEditCellValue({
        id: params.id,
        field: "allowedValues",
        value: newValue ?? [],
    });
};
const isAnyRowEditing = Object.values(dialogRowModesModel).some(
    (rowMode) => rowMode?.mode === GridRowModes.Edit
);
const allowedStatusColumns = useMemo(
  () => [
     {
      field: "actions",
      type: "actions",
      headerName: (
          <Tooltip title={handleValidateCodevalue(internationalise,"COMMON_ACTION")}>
              <img
                  src={tableEditicon}
                  style={{ paddingTop: "18px" }}
              />
          </Tooltip>
      ),
      minWidth : actionColumnWidth,
      cellClassName: "actions",

      getActions: ({ id }) => {
          const isInEditMode =
              dialogRowModesModel[id]?.mode === GridRowModes.Edit;

          const currentRow = allowedStatusRows?.find(
              (row) => row?.id === id
          );

          const isInactive =
              currentRow?.status ===  RE_STATUS?.RE_STATUS_INACTIVE;

          if (isInEditMode) {
              return [
                  <GridActionsCellItem
                      key="save"
                      icon={<CheckIcon />}
                      label={handleValidateCodevalue(internationalise,"COMMON_SAVE")}
                      className="textPrimary"
                      onClick={handleSaveClick(id)}
                  />,

                  <GridActionsCellItem
                      key="cancel"
                      icon={<CancelIcon />}
                      label={handleValidateCodevalue(internationalise,"COMMON_CANCEL")}
                      className="textPrimary"
                      onClick={handleCancelClick(id)}
                      color="inherit"
                  />,
              ];
          }

          return [
              <GridActionsCellItem
                  key="edit"
                  icon={<img src={isAnyRowEditing ? disabled_edit : tableBodyicon} />}
                  label={handleValidateCodevalue(internationalise,"COMMON_EDIT")}
                  className="textPrimary"
                  disabled = {isAnyRowEditing}
                  onClick={handleEditClick(id)}
                  color="inherit"
              />,

              <Tooltip
                  key="status"
                  title={
                      isInactive
                          ? handleValidateCodevalue(
                                internationalise,
                                "COMMON_ACTIVATE"
                            )
                          : handleValidateCodevalue(
                                internationalise,
                                "COMMON_DEACTIVATE"
                            )
                  }
              >
                  <GridActionsCellItem
                      icon={isInactive ?  <RestoreFromTrashIcon className = "main-icons" /> : <img src={trashIcon} /> }
                      label={
                          isInactive
                              ? handleValidateCodevalue(
                                    internationalise,
                                    "COMMON_ACTIVATE"
                                )
                              : handleValidateCodevalue(
                                    internationalise,
                                    "COMMON_DEACTIVATE"
                                )
                      }
                      className="textPrimary"
                      onClick={handleToggleStatus(id)}
                      color="inherit"
                  />
              </Tooltip>,
          ];
      },
},

    {
        field: "clientLookupCode",
        headerName: handleValidateCodevalue(
            internationalise,
            "RE_CLIENT_LOOKUP_CODE"
        ),
        type: "singleSelect",
        valueOptions: (params) => {
            const currentValue = params?.row?.clientLookupCode;

            return [
                ...clientLookupCodeOptions,
                ...(currentValue &&
                !clientLookupCodeOptions.includes(currentValue)
                    ? [currentValue]
                    : []),
            ];
        },
        editable: true,
        flex: 0.6,
    },

    {
        field: "allowedValues",
        headerName: handleValidateCodevalue(
            internationalise,
            "RE_ALLOWED_VALUES"
        ),
        editable: true,
        flex: 1.3,

        renderCell: (params) => (
            <Box className = "multiple-lines-column">
            {(params.value ?? []).map((item, index) => (
                <div key={index}>
                {item?.name ?? item}
                </div>
            ))}
            </Box>
        ),

renderEditCell: (params) => (
  <div className="allowed-values-edit-cell">
    <AutoCompleteComponent
      multiple
      disableCloseOnSelect
      optionSet={allowedValueOptions}
      value={params.value || []}
      name="allowedValues"
      isOptionEqualToValue={(option, val) => option?.name === val?.name}
      onChange={(event, newValue) => handleAllowedValuesChange(event, newValue, params)}
    />
  </div>
),
    },

    {
      field: "status",
      headerName: handleValidateCodevalue(internationalise, "RE_STATUS"),
      flex: 0.4,
        renderCell: (params) => {
        if (!params?.value) {
            return "";
        }

        return handleValidateCodevalue(
            internationalise,
            params.value
        );
    },
    },
  ],
  [dialogRowModesModel,clientLookupCodeOptions,allowedStatusRows, internationalise]
);

const handleEditClick = (id) => () => {
    setDialogRowModesModel({
        [id]: {
            mode: GridRowModes.Edit,
        },
    });
};

const handleSaveClick = (id) => () => {
    setDialogRowModesModel((prev) => ({
        ...prev,
        [id]: {
            mode: GridRowModes.View,
        },
    }));
};

const handleCancelClick = (id) => () => {
    setDialogRowModesModel({
          ...dialogRowModesModel,
          [id]: { mode: GridRowModes.View, ignoreModifications: true },
        });
    
        const editedRow = allowedStatusRows.find((row) => row.id === id);
        if (editedRow.isNew) {
          setAllowedStatusRows(allowedStatusRows.filter((row) => row.id !== id));
        }
};
const getAllowedLookupCodes = (row) => {
    const allowedLookupCodes = (row?.allowedValues ?? []).map(
        (item) => item?.name ?? item
    );

    const clientLookupCode = row?.clientLookupCode?.trim();

    if (
        clientLookupCode &&
        !allowedLookupCodes.includes(clientLookupCode)
    ) {
        allowedLookupCodes.push(clientLookupCode);
    }

    return allowedLookupCodes;
};

const createRowPayload = (row) => {
    return {
        lookupType: selectedEntity,
        status: row?.status,
        clientLookupCode: row?.clientLookupCode,
        allowedLookupCode: getAllowedLookupCodes(row),
    };
};
const handleAllowedStatusSave = async (updatedRow) => {
    const isNew = updatedRow?.isNew === true;
    // Find original row
    const originalRow = allowedStatusRows?.find(
        (row) => row?.id === updatedRow?.id
    );

if (
        !updatedRow?.clientLookupCode?.trim() ||
        !updatedRow?.allowedValues ||
        updatedRow?.allowedValues?.length === 0
    ) {
        handleEditClick(updatedRow?.id)();
        enqueueSnackbar(
            handleValidateCodevalue(
                internationalise,
                "RE_EMPTY_FIELD_WARNING"
            ),
            {
                variant: "warning",
            }
        );

        return updatedRow;
    }


    // Existing row → check whether anything changed
    if (!isNew) {
        const hasChanged =
            JSON.stringify(originalRow) !==
            JSON.stringify(updatedRow);

        if (!hasChanged) {
            enqueueSnackbar(
                handleValidateCodevalue(
                    internationalise,
                    "COMMON_NO_DATA_CHANGED"
                ),
                {
                    variant: "info",
                }
            );

            return originalRow;
        }
    }

    const payload = createRowPayload(updatedRow);

    try {
        dispatch(requestShowLoader());

        const url = isNew
            ? `${process.env.REACT_APP_BASE_URL}api/rule-engine`
            : `${process.env.REACT_APP_BASE_URL}api/rule-engine/${updatedRow?.id}`;

        const response = isNew
            ? await createRequestData(payload, url)
            : await updateRequestData(payload, url);

        if (response?.status === "error") {
            enqueueSnackbar(
                handleValidateCodevalue(
                    internationalise,
                    "COMMON_PLEASE_TRY_AGAIN"
                ),
                {
                    variant: "error",
                }
            );

            return updatedRow;
        }

        enqueueSnackbar(
            handleValidateCodevalue(
                internationalise,
                isNew
                    ? "COMMON_ADDED_SUCCESSFULLY"
                    : "COMMON_UPDATED_SUCCESSFULLY"
            ),
            {
                variant: "success",
            }
        );

        dispatch(requestGetAllTextfieldDetails());

        await getAllowedStatusData();

        return {
            ...updatedRow,
            isNew: false,
        };
    } catch (error) {
        console.error(
            isNew
                ? "Error creating allowed status rule:"
                : "Error updating allowed status rule:",
            error
        );

        return  updatedRow;
    } finally {
        dispatch(requestHideLoader());
    }
};

const handleAddClick = () => {
  const id = `new-${Date.now()}`;

  setAllowedStatusRows((oldRows) => [
    {
      id : id,
      clientLookupCode: "",
      allowedValues: [],
      status:  RE_STATUS?.RE_STATUS_INACTIVE,
      isNew : true
    },
    ...oldRows,
  ]);

  setDialogRowModesModel((prev) => ({
    ...prev,
    [id]: {
      mode: GridRowModes.Edit,
    },
  }));
};
  return (

    <BiztantuLoader open={isLoadingprogress} isChildren={true}>
    <LeadDialog
    open={open}
    handleClose={handleClose}
    title={handleValidateCodevalue(internationalise, "SET_STATUS_RULES_TITLE")}
    size="xl"
  >

    <InfoIcon
      text = "SET_RE_INFO"
    /> 
    <Box>
      <StyledLeadContainer className = "mb-15">
          <SelectBoxWithLabel
            name="selectedEntity"
            value={selectedEntity}
            label={handleValidateCodevalue(internationalise, "RE_DD_SELECT_LOOKUP_TYPE")}
            optionMenuItem={ruleEngineLookupList}
            handleOnChange={(event) => setSelectedEntity(event?.target?.value)}
          />
      <Tooltip
                title={handleValidateCodevalue(
                  internationalise,
                  "RE_ADD_RULE",
                )}
              >
                <Button className="biztantu-sec-btn ml-20" onClick = {handleAddClick} disabled = {isAnyRowEditing}>
                  {handleValidateCodevalue(internationalise, "RE_ADD_RULE")}
                </Button>
              </Tooltip>
              </StyledLeadContainer>
      <DataGridTable
        isCheckboxReq={false}
        dataGridData={allowedStatusRows}
        rowsToView={ROWS_TO_VIEW_IN_CHILD_TABLE}
        height = 'calc(100vh - 380px)'
        columns={allowedStatusColumns}
        handleProcessRowUpdate={handleAllowedStatusSave}
        rowModesModel={dialogRowModesModel}
        isRequiredToolBar={false}
        getRowHeight={(params) => {
            const lines = Math.max(params?.model?.allowedValues?.length || 1, 1);

            return 45 + (lines - 1) * 20;
        }}
      />
    </Box>
  </LeadDialog>
  </BiztantuLoader>
  )
}

export default AllowedStatusDialog